/* eslint-disable no-unused-vars */
import { Form, Cascader } from 'antd';
import React, { useContext, useEffect, useCallback } from 'react';
import { CascaderPackageStyled } from './CascaderPackageStyled';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import classnames from 'classnames';

const CascaderML = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  let {
    name,
    options,
    placeVal = '请选择新增字段包',
    labelVal,
    inputWidth,
    height,
    maxWidth,
    className = [],
    value,
    require,
    displayRender,
    onChange,
    disabled,
  } = props;

  let handleOnChange = (e) => {
    onChange && onChange(e);
  };
  return (
    <React.Fragment>
      <CascaderPackageStyled
        theme={themeContext}
        brand={brandContext}
        inputWidth={inputWidth}
        height={height}
      >
        <div className="cascader-box">
          <Form.Item
            colon={false}
            name={name}
            label={labelVal}
            className={classnames(...className)}
            initialValue={value}
            rules={require}
          >
            <Cascader
              style={{
                minWidth: inputWidth,
                height: height,
                maxWidth: maxWidth,
              }}
              options={options}
              onChange={handleOnChange}
              displayRender={displayRender}
              placeholder={placeVal}
              changeOnSelect={false}
              value={value}
              disabled={disabled}
            />
          </Form.Item>
        </div>
      </CascaderPackageStyled>
    </React.Fragment>
  );
};

export default CascaderML;
